export default{
  setUser(state, payload) {
      state.token = payload.token;
      state.userId = payload.userId;
      state.didAutoLogout = false;
    },
  setGoods(state,payload) {
    state.goods = payload;
  },
  setGoodsView(state,payload) {
    state.goodsview = payload;
  },
  setGoodsBuy(state, payload) {
    state.goodsBuy = payload;
  },
  updateGoodsBuy(state, payload)
  {    
    let goodsbuy = state.goodsBuy.data.find((goodsbuy)=>goodsbuy.id === payload.id);   
    
    goodsbuy.state = payload.state;
  },  
  
};
